import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 my-5" }
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "font-semibold mt-4" }
const _hoisted_7 = { class: "text-sm text-grey-500" }
const _hoisted_8 = { class: "s13 flex justify-content-right" }
const _hoisted_9 = { class: "form-field-floating default sm s4_mobile ml-3" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "filter-set-area",
  style: {"display":"block"}
}
const _hoisted_12 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_13 = { class: "form-field-floating reactive sm" }
const _hoisted_14 = { class: "form-field-floating reactive sm" }
const _hoisted_15 = { class: "form-field-floating reactive sm" }
const _hoisted_16 = { class: "form-field-floating sm" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "table separator skin2 selection" }
const _hoisted_19 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_20 = ["checked"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "selection-item" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = { class: "mb-1 font-semibold" }
const _hoisted_26 = { class: "text-sm text-grey-500" }
const _hoisted_27 = { class: "flex-right" }
const _hoisted_28 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { computed, onMounted, reactive, ref, toRaw } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import axios from 'axios';
    import { useRoute } from 'vue-router';
import { formatAmount, formatDate } from '@/utils';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCommandesListView',
  setup(__props) {

    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });
    const startupInfos = reactive({
        users: [] as any[]
    });
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'DESC',
        sortColumn: 'created_at',
        sortOption: 'created_at_desc',
        borneInf: '',
        borneSup: '',
        user_id: '',
        search: '',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
    ]

    onMounted(() => {
        const sortParam = route.query.sort as string;
        if (sortParam) { queryParams.sortOption = sortParam; onFiltersChanged(); }
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/market-commandes/list?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

    function onFiltersChanged() {
        const sortItem = SORT_OPTIONS.find(o => o.value == queryParams.sortOption);
        if (sortItem) {
            queryParams.sortColumn = sortItem.sort_column;
            queryParams.sortDir = sortItem.sort_direction;
        }
        doListItems();
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, [
                _cache[7] || (_cache[7] = _createTextVNode(" Commandes ", -1)),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(pagination.total) + ")", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("button", { class: "btn normal ml-4 justify-content-center btn-filtre" }, [
                _createElementVNode("img", {
                  src: "/icons/icon-add.svg",
                  class: "btn-icon",
                  alt: ""
                }),
                _createElementVNode("span", null, "Créer")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  id: "filters_sort",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.sortOption) = $event)),
                  onChange: onFiltersChanged
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SORT_OPTIONS, (option, index) => {
                    return _createElementVNode("option", {
                      value: option.value,
                      key: 'filter_sort_' + index
                    }, _toDisplayString(option.label), 9, _hoisted_10)
                  }), 64))
                ], 544), [
                  [_vModelSelect, queryParams.sortOption]
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("button", { class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter" }, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter.svg",
                  class: "btn-icon",
                  alt: ""
                }),
                _createElementVNode("span", null, "Options")
              ], -1))
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    id: "filters_search",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.search) = $event)),
                    placeholder: "",
                    onKeyup: _withKeys(onFiltersChanged, ["enter"])
                  }, null, 544), [
                    [_vModelText, queryParams.search]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "filters_search" }, "Recherche", -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    id: "filters_borne_inf",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.borneInf) = $event)),
                    placeholder: "",
                    onChange: onFiltersChanged
                  }, null, 544), [
                    [_vModelText, queryParams.borneInf]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("label", { for: "filters_borne_inf" }, "Date de création >=", -1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    id: "filters_borne_sup",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.borneSup) = $event)),
                    placeholder: "",
                    onChange: onFiltersChanged
                  }, null, 544), [
                    [_vModelText, queryParams.borneSup]
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("label", { for: "filters_borne_sup" }, "Date de création <=", -1))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    id: "filters_user",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.user_id) = $event)),
                    onChange: onFiltersChanged
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Tous les user", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.users, (option, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: option.id,
                        key: 'filter_user_' + index
                      }, _toDisplayString(option.nom), 9, _hoisted_17))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, queryParams.user_id]
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("label", { for: "filters_user" }, [
                    _createTextVNode("Utilisateur "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ])
              ])
            ])
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("hr", { class: "s20 my-0 hr2 opacity-1" }, null, -1)),
          _createElementVNode("table", _hoisted_18, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_19, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_20)
                  ])
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("th", null, null, -1)),
                _cache[17] || (_cache[17] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-down.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Date")
                ], -1)),
                _cache[18] || (_cache[18] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Utilisateur")
                ], -1)),
                _cache[19] || (_cache[19] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Num commande")
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Status")
                ], -1)),
                _cache[21] || (_cache[21] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Montant")
                ], -1)),
                _cache[22] || (_cache[22] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Mode Paiement")
                ], -1)),
                _cache[23] || (_cache[23] = _createElementVNode("th", { class: "flex-right" }, [
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-destroy.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Détruire")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra white2 tips" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-delete.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Supprimer")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra white2 tips" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-restaurer.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Restaurer")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra color2 tips" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-actif.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Actif")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (itemsList.value.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("td", { colspan: "5" }, [
                      _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "text-grey-700 over-effect",
                  key: 'item_' + index
                }, [
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("label", {
                      class: "btn-circle",
                      for: 'item_check_' + index
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "selectedItems[]",
                        id: 'item_check_' + index,
                        value: item.id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedItems).value = $event))
                      }, null, 8, _hoisted_24), [
                        [_vModelCheckbox, selectedItems.value]
                      ])
                    ], 8, _hoisted_23)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("td", { class: "flex" }, [
                    _createElementVNode("div", {
                      class: "square-xl rounded-15",
                      style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                    }, [
                      _createElementVNode("img", {
                        src: "/assets/users/300w/user2.jpg",
                        width: "100%"
                      })
                    ]),
                    _createElementVNode("div", {
                      class: "square-xl rounded-15 ml-3 px-3 py-3",
                      style: {"background-color":"rgb(var(--color-info-rgb), 0.2)"}
                    }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-menu-carte.svg",
                        width: "100%"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(item.created_at)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("h5", _hoisted_25, _toDisplayString(item.user.nom + ' ' + item.user.prenom), 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.user.fonction), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.num_commande), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.statut), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(_unref(formatAmount)(item.total)), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.mode_paiement), 1)
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _createVNode(_component_router_link, {
                      to: '/app/market/market-commandes/' + item.id
                    }, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("button", { class: "btn white2 collapse-open-table" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-list.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Plus")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[6] || (_cache[6] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ])
      ])
    ]),
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})